import RoofRange from "./RoofRange";
import Konva from "konva";
import { Global } from "../utilities/global";
import { SC_Input } from "../input/SC_Input";
import { Statics } from "../utilities/statics";
import { getCanvasLine } from "../konva/getCanvas";
import { Point } from "../area/Point";
import { Modul } from "../panel/Modul";
import { ModulProp } from "../panel/ModulProp";
import { Sol50OnRoof } from "../mountsys/Sol50OnRoof";
import { Sol50Integrated } from "../mountsys/Sol50Integrated";
import { Sol50 } from "../mountsys/Sol50";
import { ScaleAdjustmentValue } from "../getScaleFactor";
import * as konva from "../konva/getCanvas";
import { DrawRoofForPanel } from '../panel/drawRoofForPanel';
import DrawPanels from "../konva/drawPanels";

export class Hip {
	/* Gesamte Dachfläche */
	//Dachhöhe
	static nRoofHeight: number;
	//Dachbreite (Traufe)
	static nRoofWidth: number;
	//Obere Kante Breite
	static nTopWidth: number;
	//Obere Kante Links
	static nTopLeft: number;
	//Untere Kante Links
	static nBottomLeft: number;
	/* H */
	//Höhe Bereich H
	nHHeight: number;
	//Obere Kante Links von H
	nHTopLeft: number;
	//Obere Kante Breite
	nHTopWidth: number;
	//Untere Kante Links von H
	nHBottomLeft: number;
	static nE10Top: number;
	static nE10Bottom: number;
	static nE10Side: number;
	static nE4Bottom: number;
	nE4Side: number;
	static rrFSideLeft: RoofRange;
	static rrFSideRight: RoofRange;
	static rrFBottomLeft: RoofRange;
	static rrFBottomRight: RoofRange;
	static rrGTop: RoofRange;
	static rrGBottom: RoofRange;
	nCurY: number;
	nDifLeft: number;
	nMaxW: number;
	static hblx1: number;
	static hbly1: number;
	static hbrx2: number;
	static hbry2: number;
	static htrx3: number;
	static htry3: number;
	static htlx4: number;
	static htly4: number;

	public fitWalm(): void {
		var modulTmp: Modul;
		var i: number, j: number;
		var iRowTop: number, iBestRowTop: number;
		var iRowBottom: number, iNumRows: number;
		var nMaxW: number, nCurY: number, nDifLeft: number;
		var nCenterVal: number;
		var nModWidth: number, nModHeight: number;
		var iCols: number;
		if (SC_Input.iModAlignment == ModulProp.ORIENTATION_HORIZONTAL) {
			nModWidth = SC_Input.nModHeight / 10;
			nModHeight = SC_Input.nModWidth / 10;
		} else {
			nModWidth = SC_Input.nModWidth / 10;
			nModHeight = SC_Input.nModHeight / 10;
		}
		iNumRows = Math.floor(Sol50.getAvailHeight(Hip.nRoofHeight) / nModHeight);
		const allPanels = [];
		for (i = 1; i <= iNumRows; i++) {
			nCurY = Hip.nRoofHeight - (((nModHeight + Sol50.nVertikalAbstand) * i) + Sol50.nVertikalAbschluss);
			nDifLeft = ((Hip.nTopLeft - Hip.nBottomLeft) / Hip.nRoofHeight) * nCurY;
			nMaxW = Hip.nTopWidth + (nDifLeft * 2);
			iCols = Sol50.calcCols(nMaxW, nModWidth);
			nCenterVal = (nMaxW - (iCols * (nModWidth + Sol50.nHorizontalAbstand))) / 2;
			for (j = 0; j < iCols; j++) {
				// modulTmp = new Modul(nModWidth, nModHeight);
				var x = ((nModWidth + Sol50.nHorizontalAbstand) * j) + (Hip.nTopLeft - nDifLeft) + nCenterVal;
				var y = nCurY;
				allPanels.push({x: ScaleAdjustmentValue.getScaleAdjust(x), y: ScaleAdjustmentValue.getScaleAdjust(y), w: nModWidth, h: nModHeight});
				// modulTmp = new Modul(ScaleAdjustmentValue.getScaleAdjust(x), ScaleAdjustmentValue.getScaleAdjust(y), nModWidth, nModHeight);
				// modulTmp.draw(DrawRoofForPanel.panelGroup);
			}
		}
		new DrawPanels().drawPanels(allPanels);
	}
	public fitWalmIndach(): void {
		var modulTmp: Modul;
		var i: number, j: number;
		var nMaxW: number, nCurY: number, nDifLeft: number;
		var nCenterVal: number;
		var nModWidth: number, nModHeight: number;
		var iCols: number, iRows: number;
		var iTryStep: number;
		var nWingFactor: number;
		var iMaxMod: number;
		var iMaxCol: number = 0;
		var iMaxRow: number = 0;
		var iMaxStartY: number = 0;
		var nMaxGenWidth: number;
		var nCurX: number;

		if (SC_Input.iModAlignment == ModulProp.ORIENTATION_HORIZONTAL) {
			nModWidth = SC_Input.nModHeight /10;
			nModHeight = SC_Input.nModWidth /10;
		} else {
			nModWidth = SC_Input.nModWidth /10;
			nModHeight = SC_Input.nModHeight /10;
		}
		// Modul.width = nModWidth;
		// Modul.height = nModHeight;

		nWingFactor = ((Hip.nTopLeft - Hip.nBottomLeft) / Hip.nRoofHeight);
		//Mit 50cm-Schritten probieren
		iTryStep = 50;
		iMaxMod = 0;
		i = Hip.nRoofHeight - (nModHeight + Sol50Integrated.nEindeckblechZusatz);
		while (i > iTryStep) {
			nDifLeft = nWingFactor * (Hip.nRoofHeight - i);
			//available width
			nMaxW = Hip.nRoofWidth - (nDifLeft * 2);
			//generator width
			nMaxGenWidth = nMaxW - Sol50Integrated.nRandLeftRight;
			iCols = Sol50.calcCols(nMaxGenWidth, nModWidth);
			iRows = Sol50.calcRowsFromHeight(Hip.nRoofHeight - i, nModHeight);
			if (iMaxMod <= iCols * iRows) {
				iMaxMod = iCols * iRows;
				iMaxCol = iCols;
				iMaxRow = iRows;
				iMaxStartY = i;
			} else {
				break;
			}
			i -= nModHeight + Sol50.nVertikalAbstand;
		}
		if (iMaxMod == 0) {
			//Keine Module bebaubar
			return;
		}
		//nDifLeft einmalig berechnen, da x-Position immer gleich bleibt
		nCurY = iMaxStartY;
		nDifLeft = nWingFactor * (Hip.nRoofHeight - nCurY);
		nCenterVal = (Hip.nRoofWidth - (nDifLeft * 2)) - (iMaxCol * (nModWidth + Sol50.nHorizontalAbstand) - Sol50.nHorizontalAbstand);//((nMaxW - Sol50.nHorizontalAbstand) - (iMaxCol * (nModWidth + Sol50.nHorizontalAbstand))) / 2;
		nCenterVal = nCenterVal / 2;
		const allPanels: any = [];
		for (i = 0; i < iMaxRow; i++) {
			nCurY = iMaxStartY + (i * (nModHeight + Sol50.nVertikalAbstand));
			//				nDifLeft = nWingFactor * nCurY;
			for (j = 0; j < iMaxCol; j++) {
				// modulTmp = new Modul(nModWidth, nModHeight);
				var x = ((nModWidth + Sol50.nHorizontalAbstand) * j) + nDifLeft + nCenterVal;
				var y = nCurY;
				allPanels.push({x: ScaleAdjustmentValue.getScaleAdjust(x), y: ScaleAdjustmentValue.getScaleAdjust(y), w: nModWidth, h: nModHeight});
				// modulTmp.draw(DrawRoofForPanel.panelGroup);
			}
		}
		new DrawPanels().drawPanels(allPanels);
	}
	drawHip(layer: Konva.Layer) {
		var a: number, b: number, c: number;
		var nWing: number;
		var iBuilding = SC_Input.iBuilding * 100;
		a = SC_Input.a;
		b = SC_Input.b;
		c = SC_Input.c;
		nWing = (b - c) / 2;
		Hip.nRoofHeight = a;
		Hip.nRoofWidth = b;
		Hip.nTopWidth = c;
		Hip.nBottomLeft = 0;
		Hip.nTopLeft = nWing;
		Hip.nE10Bottom = Statics.getE10(b, iBuilding);
		Hip.nE4Bottom = Statics.getE4(b, iBuilding);
		Hip.nE10Top = Statics.getE10(c, iBuilding);
		Hip.nE10Side = Statics.getE10(Math.sqrt(nWing * nWing + a * a), iBuilding);
		this.nE4Side = Statics.getE4(Math.sqrt(nWing * nWing + a * a), iBuilding);
		var hipshape = getCanvasLine({
			points: [ScaleAdjustmentValue.getScaleAdjust(nWing),
			ScaleAdjustmentValue.getScaleAdjust(0),
			ScaleAdjustmentValue.getScaleAdjust(b - nWing),
			ScaleAdjustmentValue.getScaleAdjust(0),
			ScaleAdjustmentValue.getScaleAdjust(b),
			ScaleAdjustmentValue.getScaleAdjust(a),
			ScaleAdjustmentValue.getScaleAdjust(0),
			ScaleAdjustmentValue.getScaleAdjust(a)],
			fill: SC_Input.color,
			closed: true,
		});
		layer.add(hipshape);
		layer.draw();

		a = SC_Input.a - (Hip.nE10Bottom + Hip.nE10Top);


		this.createStaticsAreas(layer);
	}

	createStaticsAreas(layer: Konva.Layer) {
		var nX: number, nY: number;
		var nBottomBorderTopLeft: number;
		var nTopBorderBottomLeft: number;
		nBottomBorderTopLeft = ((Hip.nTopLeft - Hip.nBottomLeft) / Hip.nRoofHeight) * Hip.nE10Bottom;
		nTopBorderBottomLeft = ((Hip.nTopLeft - Hip.nBottomLeft) / Hip.nRoofHeight) * (Hip.nRoofHeight - Hip.nE10Top);
		/* F */
		//FBottomLeft
		Hip.rrFBottomLeft = new RoofRange(Global.colDachF);
		nX = 0;
		nY = Hip.nRoofHeight;
		Hip.rrFBottomLeft.pBottomLeft = new Point(nX, nY);

		nX = Hip.nE4Bottom;
		nY = Hip.nRoofHeight;
		Hip.rrFBottomLeft.pBottomRight = new Point(nX, nY);

		nX = nBottomBorderTopLeft;
		nY = Hip.nRoofHeight - Hip.nE10Bottom;
		Hip.rrFBottomLeft.pTopLeft = new Point(nX, nY);

		nX = Hip.nE4Bottom;
		nY = Hip.nRoofHeight - Hip.nE10Bottom;
		Hip.rrFBottomLeft.pTopRight = new Point(nX, nY);
		Hip.rrFBottomLeft.draw(layer);
		Hip.rrFBottomLeft.setLabel("F");

		//FSideLeft
		Hip.rrFSideLeft = new RoofRange(Global.colDachF);
		nX = 0;
		nY = Hip.nRoofHeight;
		Hip.rrFSideLeft.pBottomLeft = new Point(nX, nY);

		nX = Hip.nE10Side;
		nY = Hip.nRoofHeight;
		Hip.rrFSideLeft.pBottomRight = new Point(nX, nY);

		nX = Hip.nTopLeft;
		nY = 0;
		Hip.rrFSideLeft.pTopLeft = new Point(nX, nY);

		nX = Hip.nTopLeft + Hip.nE10Side;
		nY = 0;
		Hip.rrFSideLeft.pTopRight = new Point(nX, nY);
		Hip.rrFSideLeft.draw(layer);
		Hip.rrFSideLeft.setLabel("F");

		//FBottomRight
		Hip.rrFBottomRight = new RoofRange(Global.colDachF);
		nX = Hip.nRoofWidth - Hip.nE4Bottom;
		nY = Hip.nRoofHeight;
		Hip.rrFBottomRight.pBottomLeft = new Point(nX, nY);

		nX = Hip.nRoofWidth;
		nY = Hip.nRoofHeight;
		Hip.rrFBottomRight.pBottomRight = new Point(nX, nY);

		nX = Hip.nRoofWidth - Hip.nE4Bottom;
		nY = Hip.nRoofHeight - Hip.nE10Bottom;
		Hip.rrFBottomRight.pTopLeft = new Point(nX, nY);

		nX = Hip.nRoofWidth - nBottomBorderTopLeft;
		nY = Hip.nRoofHeight - Hip.nE10Bottom;
		Hip.rrFBottomRight.pTopRight = new Point(nX, nY);
		Hip.rrFBottomRight.draw(layer);
		Hip.rrFBottomRight.setLabel("F");

		//FSideRight
		Hip.rrFSideRight = new RoofRange(Global.colDachF);
		nX = Hip.nRoofWidth - Hip.nE10Side;
		nY = Hip.nRoofHeight;
		Hip.rrFSideRight.pBottomLeft = new Point(nX, nY);

		nX = Hip.nRoofWidth;
		nY = Hip.nRoofHeight;
		Hip.rrFSideRight.pBottomRight = new Point(nX, nY);

		nX = Hip.nRoofWidth - (Hip.nTopLeft + Hip.nE10Side);
		nY = 0;
		Hip.rrFSideRight.pTopLeft = new Point(nX, nY);

		nX = Hip.nRoofWidth - Hip.nTopLeft;
		nY = 0;
		Hip.rrFSideRight.pTopRight = new Point(nX, nY);
		Hip.rrFSideRight.draw(layer);
		Hip.rrFSideRight.setLabel("F");

		/* G */
		//GBottom
		Hip.rrGBottom = new RoofRange(Global.colDachG);
		nX = Hip.nE4Bottom > Hip.nE10Side ? Hip.nE4Bottom : Hip.nE10Side;
		nY = Hip.nRoofHeight;
		Hip.rrGBottom.pBottomLeft = new Point(nX, nY);

		nX = Hip.nE4Bottom > Hip.nE10Side ? Hip.nRoofWidth - Hip.nE4Bottom : Hip.nRoofWidth - Hip.nE10Side;
		nY = Hip.nRoofHeight;
		Hip.rrGBottom.pBottomRight = new Point(nX, nY);

		nX = Hip.nE4Bottom > nBottomBorderTopLeft + Hip.nE10Side ? Hip.nE4Bottom : nBottomBorderTopLeft + Hip.nE10Side;
		nY = Hip.nRoofHeight - Hip.nE10Bottom;
		Hip.rrGBottom.pTopLeft = new Point(nX, nY);

		nX = Hip.nE4Bottom > nBottomBorderTopLeft + Hip.nE10Side ? Hip.nRoofWidth - Hip.nE4Bottom : Hip.nRoofWidth - (nBottomBorderTopLeft + Hip.nE10Side);
		nY = Hip.nRoofHeight - Hip.nE10Bottom;
		Hip.rrGBottom.pTopRight = new Point(nX, nY);
		Hip.rrGBottom.draw(layer);
		Hip.rrGBottom.setLabel("G");

		//GTop
		Hip.rrGTop = new RoofRange(Global.colDachG);
		nX = nTopBorderBottomLeft + Hip.nE10Side;
		nY = Hip.nE10Top;
		Hip.rrGTop.pBottomLeft = new Point(nX, nY);

		nX = Hip.nRoofWidth - nX;
		nY = Hip.nE10Top;
		Hip.rrGTop.pBottomRight = new Point(nX, nY);

		nX = Hip.nTopLeft + Hip.nE10Side;
		nY = 0;
		Hip.rrGTop.pTopLeft = new Point(nX, nY);

		nX = Hip.nRoofWidth - nX;
		nY = 0;
		Hip.rrGTop.pTopRight = new Point(nX, nY);
		Hip.rrGTop.draw(layer);
		Hip.rrGTop.setLabel("G");

		Hip.drawHipStatics(layer);
	}

	static drawHipStatics(l: any): void {
		var a: number, b: number, c: number;
		var nWing: number;
		var nDifLeft: number, nMaxW: number, nCurY: number;
		var nX: number;
		if (SC_Input.bNoRange) {
			return;
		}
		a = SC_Input.a - (Hip.nE10Bottom + Hip.nE10Top);

		var nCurY: number = SC_Input.a - Hip.nE10Bottom;
		nDifLeft = ((Hip.nTopLeft - Hip.nBottomLeft) / Hip.nRoofHeight) * nCurY;
		nMaxW = SC_Input.c + (nDifLeft * 2);
		b = nMaxW - (Hip.nE10Side * 2);
		nX = (SC_Input.b - b) / 2;

		nCurY = Hip.nE10Top;
		nDifLeft = ((Hip.nTopLeft - Hip.nBottomLeft) / Hip.nRoofHeight) * nCurY;
		nMaxW = SC_Input.c + (nDifLeft * 2);
		c = nMaxW - (Hip.nE10Side * 2);

		nWing = (b - c) / 2;
		// nHHeight = a;
		// nHTopWidth = c;
		// nHBottomLeft = nX;
		// nHTopLeft = nWing + nX;

		// createStaticsAreas();

		// Global.canRoof.graphics.beginFill(Global.colE10);
		// Global.canRoof.graphics.lineStyle(1, 0x000000);
		// console.log(nWing + nX, Hip.nE10Top);
		// console.log(nX, a + Hip.nE10Top);
		// console.log(b + nX, a + Hip.nE10Top);
		// console.log((b - nWing) + nX, Hip.nE10Top);
		Hip.hblx1 = ScaleAdjustmentValue.getScaleAdjust(nWing + nX)
		Hip.hbly1 = ScaleAdjustmentValue.getScaleAdjust(Hip.nE10Top);
		Hip.hbrx2 = ScaleAdjustmentValue.getScaleAdjust((b - nWing) + nX);
		Hip.hbry2 = ScaleAdjustmentValue.getScaleAdjust(Hip.nE10Top);
		Hip.htrx3 = ScaleAdjustmentValue.getScaleAdjust(b + nX);
		Hip.htry3 = ScaleAdjustmentValue.getScaleAdjust(a + Hip.nE10Top);
		Hip.htlx4 = ScaleAdjustmentValue.getScaleAdjust(nX);
		Hip.htly4 = ScaleAdjustmentValue.getScaleAdjust(a + Hip.nE10Top);

		// console.log(nWing + nX, Hip.nE10Top);
		// Global.canRoof.graphics.endFill();
		var innearHarea = getCanvasLine({
			points: [
				ScaleAdjustmentValue.getScaleAdjust(nWing + nX),
				ScaleAdjustmentValue.getScaleAdjust(Hip.nE10Top),
				ScaleAdjustmentValue.getScaleAdjust(nX),
				ScaleAdjustmentValue.getScaleAdjust(a + Hip.nE10Top),
				ScaleAdjustmentValue.getScaleAdjust(b + nX),
				ScaleAdjustmentValue.getScaleAdjust(a + Hip.nE10Top),
				ScaleAdjustmentValue.getScaleAdjust((b - nWing) + nX),
				ScaleAdjustmentValue.getScaleAdjust(Hip.nE10Top)],
			fill: SC_Input.color,
			closed: true,
			stroke: '#000000',
			strokeWidth: 2,
			opacity: 0,
        	name: 'innerAreaShape'
		});
		l.add(innearHarea);
		innearHarea.draw();
	}
	public static getRangeByModule(panel: any): string {
		if (panel && panel.length > 0) {
			var obj = panel[0];

			var harea: boolean = false, htouch: boolean = false, garea: boolean = false, gtouch: boolean = false, farea: boolean = false;
			var farea: boolean = false, ftouch: boolean = false;
			var x = obj.getAttrs().x;
			var y = obj.getAttrs().y;
			var w = obj.getAttrs().width;
			var h = obj.getAttrs().height;

			let tl, tr, bl, br;
			var x1, y1;
			// G area Top
			tl = Hip.rrGTop.pTopLeft
			tr = Hip.rrGTop.pTopRight
			bl = Hip.rrGTop.pBottomLeft
			br = Hip.rrGTop.pBottomRight
			x1 = x;
			y1 = y;
			let gt1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x + w;
			y1 = y;
			let gt2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x;
			y1 = y + h;
			let gt3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x + w;
			y1 = y + h;
			let gt4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			if (gt1 && gt2 && gt3 && gt4) {
				garea = true;
			} else if (gt1 || gt2 || gt3 || gt4) {
				gtouch = true;
			}
			// G area Bottom
			tl = Hip.rrGBottom.pTopLeft
			tr = Hip.rrGBottom.pTopRight
			bl = Hip.rrGBottom.pBottomLeft
			br = Hip.rrGBottom.pBottomRight
			x1 = x;
			y1 = y;
			let gb1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x + w;
			y1 = y;
			let gb2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x;
			y1 = y + h;
			let gb3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x + w;
			y1 = y + h;
			let gb4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			if (gb1 && gb2 && gb3 && gb4) {
				garea = true;
			} else if (gb1 || gb2 || gb3 || gb4) {
				gtouch = true;
			}

			// F Left side
			x1 = x;
			y1 = y;

			let fsl1 = x1 > Hip.getDiffLeft(y1) && x1 < Hip.getDiffLeft(y1) + Hip.nE4Bottom;
			x1 = x + w;
			y1 = y;
			let fsl2 = x1 > Hip.getDiffLeft(y1) && x1 < Hip.getDiffLeft(y1) + Hip.nE4Bottom;
			x1 = x;
			y1 = y + h;
			let fsl3 = x1 > Hip.getDiffLeft(y1) && x1 < Hip.getDiffLeft(y1) + Hip.nE4Bottom;
			x1 = x + w;
			y1 = y + h;
			let fsl4 = x1 > Hip.getDiffLeft(y1) && x1 < Hip.getDiffLeft(y1) + Hip.nE4Bottom;
			if (fsl1 && fsl2 && fsl3 && fsl4) {
				farea = true;
				// console.log("panel is in gBottom area");
			} else if (fsl1 || fsl2 || fsl3 || fsl4) {
				// console.log("panel is touching gBottom area");
				ftouch = true;
			}

			// F Right side

			// x1 = x;
			// y1 = y;
			// console.log(x1 , (Hip.nRoofWidth - Hip.getDiffLeft(y1)), (Hip.nRoofWidth - Hip.getDiffLeft(y1)) - Hip.nE4Bottom);
			// let fsr1 = x1 < (Hip.nRoofWidth - Hip.getDiffLeft(y1)) && x1 > (Hip.nRoofWidth - Hip.getDiffLeft(y1)) - Hip.nE4Bottom;
			// x1 = x + w;
			// y1 = y;
			// let fsr2 = x1 < (Hip.nRoofWidth - Hip.getDiffLeft(y1)) && x1 > (Hip.nRoofWidth - Hip.getDiffLeft(y1)) - Hip.nE4Bottom;
			// x1 = x;
			// y1 = y + h;
			// let fsr3 = x1 < (Hip.nRoofWidth - Hip.getDiffLeft(y1)) && x1 > (Hip.nRoofWidth - Hip.getDiffLeft(y1)) - Hip.nE4Bottom;
			// x1 = x + w;
			// y1 = y + h;
			// let fsr4 = x1 < (Hip.nRoofWidth - Hip.getDiffLeft(y1)) && x1 > (Hip.nRoofWidth - Hip.getDiffLeft(y1)) - Hip.nE4Bottom;
			// if (fsr1 && fsr2 && fsr3 && fsr4) {
			// 	farea = true;
			// 	// console.log("panel is in gBottom area");
			// } else if (fsr1 || fsr2 || fsr3 || fsr4) {
			// 	// console.log("panel is touching gBottom area");
			// 	ftouch = true;
			// }

			// F Bottom left
			tl = Hip.rrFBottomLeft.pTopLeft
			tr = Hip.rrFBottomLeft.pTopRight
			bl = Hip.rrFBottomLeft.pBottomLeft
			br = Hip.rrFBottomLeft.pBottomRight
			x1 = x;
			y1 = y;
			let fbl1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x + w;
			y1 = y;
			let fbl2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x;
			y1 = y + h;
			let fbl3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x + w;
			y1 = y + h;
			let fbl4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			if (fbl1 && fbl2 && fbl3 && fbl4) {
				farea = true;
			} else if (fbl1 || fbl2 || fbl3 || fbl4) {
				ftouch = true;
			}
			// Fvbottom rightv
			tl = Hip.rrFBottomRight.pTopLeft
			tr = Hip.rrFBottomRight.pTopRight
			bl = Hip.rrFBottomRight.pBottomLeft
			br = Hip.rrFBottomRight.pBottomRight
			x1 = x;
			y1 = y;
			let fbr1 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x + w;
			y1 = y;
			let fbr2 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x;
			y1 = y + h;
			let fbr3 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			x1 = x + w;
			y1 = y + h;
			let fbr4 = Statics.isModuleInRange(x1, y1, tl, tr, bl, br);
			if (fbr1 && fbr2 && fbr3 && fbr4) {
				farea = true;
			} else if (fbr1 || fbr2 || fbr3 || fbr4) {
				ftouch = true;
			}

			// H area 

			x1 = x;
			y1 = y;
			let h1 = Statics.isInside(Hip.hblx1, Hip.hbly1, Hip.hbrx2, Hip.hbry2, Hip.htrx3, Hip.htry3, x1, y1) || Statics.isInside(Hip.hblx1, Hip.hbly1, Hip.htlx4, Hip.htly4, Hip.htrx3, Hip.htry3, x1, y1);
			x1 = x + w;
			y1 = y;
			let h2 = Statics.isInside(Hip.hblx1, Hip.hbly1, Hip.hbrx2, Hip.hbry2, Hip.htrx3, Hip.htry3, x1, y1) || Statics.isInside(Hip.hblx1, Hip.hbly1, Hip.htlx4, Hip.htly4, Hip.htrx3, Hip.htry3, x1, y1);
			x1 = x;
			y1 = y + h;
			let h3 = Statics.isInside(Hip.hblx1, Hip.hbly1, Hip.hbrx2, Hip.hbry2, Hip.htrx3, Hip.htry3, x1, y1) || Statics.isInside(Hip.hblx1, Hip.hbly1, Hip.htlx4, Hip.htly4, Hip.htrx3, Hip.htry3, x1, y1);
			x1 = x + w;
			y1 = y + h;
			let h4 = Statics.isInside(Hip.hblx1, Hip.hbly1, Hip.hbrx2, Hip.hbry2, Hip.htrx3, Hip.htry3, x1, y1) || Statics.isInside(Hip.hblx1, Hip.hbly1, Hip.htlx4, Hip.htly4, Hip.htrx3, Hip.htry3, x1, y1);
			if (h1 && h2 && h3 && h4) {
				harea = true;
			} else if (h1 || h2 || h3 || h4) {
				htouch = true;
			}

			// if (farea) return "F"
			if (garea) return "G";
			else if (harea) return "H";
			else if (htouch && gtouch) return "G"; else "F";
		}
		return ""

	}
	static getDiffLeft(value: number) {
		value = value - 100;
		const r = (Hip.nTopLeft - Hip.nBottomLeft) / Hip.nRoofHeight * (Hip.nRoofHeight - value);
		return ScaleAdjustmentValue.getScaleAdjust(r);
	}
}